import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { Router } from "@angular/router";
import { NbDialogRef, NbDialogService, NbToastrService } from "@nebular/theme";
import * as _ from "lodash";
import * as moment from "moment";
import { LocalDataSource } from "ng2-smart-table";
import { Subject } from "rxjs";
import { map, takeUntil } from "rxjs/operators";
import { User } from "../../@core/data/users";
import { UserService } from "../../@core/services/user.service";
import { convertTimestamp } from "../../@core/utils/convertTimestamps.service";
import { Customer } from "../../models/customer.model";
import { Dept, DeptDetail } from "../../models/dept.model";
import { Finance } from "../../models/finance.model";
import { Person } from "../../models/person.model";
import { Catalog } from "../../models/product.model";
import { Receipt } from "../../models/receipt.model";
import Shop from "../../models/shop.model";
import { CatalogService } from "../../services/catalog.service";

import { CustomerService } from "../../services/customer.service";
import { FinanceService } from "../../services/finance.service";
import { PersonService } from "../../services/person.service";
import { ReceiptService } from "../../services/receipt.service";
import { DialogFinanceComponent } from "../dialog-finance/dialog-finance.component";
import { DialogPrintDeptDetailsComponent } from "../dialog-print-dept-details/dialog-print-dept-details.component";
import { DialogViewReceiptComponent } from "../dialog-view-receipt/dialog-view-receipt.component";
import { DialogDeptCustomerArchiveComponent } from "../dialogs/dialog-dept-customer-archive/dialog-dept-customer-archive.component";
import { ShopService } from "../../services/shop.service";

@Component({
  selector: "ngx-dialog-dept-customer",
  templateUrl: "dialog-dept-customer.component.html",
  styleUrls: ["dialog-dept-customer.component.scss"],
})
export class DialogDeptCustomerComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  @Input() header: string;
  @Input() mode: string;
  @Input() uid: string;
  @Input() shopId: string;
  @Input() shop: Shop;
  @Input() user: User;
  @Input() customer: Customer = new Customer();

  allFinances?: Finance[] = [];
  allReceipts?: Receipt[] = [];

  allDebits?: Dept[] = [];
  receiptDebits?: Dept[] = [];
  paymentDebits?: Dept[] = [];
  deptDetail?: DeptDetail[] = [];

  fromDate: Date = moment().startOf("month").toDate();
  toDate: Date = moment().endOf("month").toDate();
  selectedTime: any = null;

  receiptCount = 0;
  source: LocalDataSource = new LocalDataSource();

  saleAmount = 0;
  paidAmount = 0;
  debitAmount = 0;
  profitAmount = 0;
  totalQuantity = 0;
  discountAmount = 0;
  isDetail = false;

  //display filter by date
  initAmount = 0;
  displaySaleAmount = 0;
  displayPaidAmount = 0;
  displayDebitAmount = 0;
  displayDiscountAmount = 0;
  displayDebits?: Dept[] = [];
  displayDeptDetail?: DeptDetail[] = [];
  displayPaymentDebits?: Dept[] = [];

  submitted = false;
  loading = false;

  groupFins?: Catalog[];
  persons?: Person[];

  constructor(
    protected ref: NbDialogRef<DialogDeptCustomerComponent>,
    private userService: UserService,
    private receiptService: ReceiptService,
    private fb: FormBuilder,
    private customerService: CustomerService,
    private catalogService: CatalogService,
    private personService: PersonService,
    private financeService: FinanceService,
    private router: Router,
    private dialogService: NbDialogService,
    public shopService: ShopService,
    private toastrService: NbToastrService,
  ) {}

  ngOnInit() {
    this.customer.hadChange = false;
    console.log(
      "🚀 ~ DialogDeptCustomerComponent ~ ngOnInit ~ this.customer:",
      this.customer,
    );

    this.selectedTime = {
      periodDate: moment().startOf("month").toDate(),
      fromDate: this.fromDate,
      toDate: this.toDate,
      type: "thisMonth",
      period: "thisMonth",
    };

    this.saleAmount = this.customer.saleAmount;
    this.paidAmount = this.customer.paidAmount;
    this.debitAmount = this.customer.debitAmount;

    if (
      this.customer.shopIdArchived != null &&
      this.customer.shopIdArchived !== "" &&
      this.customer.archivedId != null &&
      this.customer.archivedId !== "" &&
      this.customer.isInitDept !== true
    ) {
      this.archiveData();
    } else {
      this.calculateCustomerStats(true);
    }

    this.getCatalogs();
    this.getPersons();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  close() {
    this.ref.close(this.customer);
  }

  print() {
    this.dialogService
      .open(DialogPrintDeptDetailsComponent, {
        context: {
          shopId: this.shopId,
          shop: this.shop,
          uid: this.uid,
          user: this.user,
          object: this.customer,
          mode: "customer",
          type: "print",
          fromDate:
            this.selectedTime.periodType === "now" ? null : this.fromDate,
          toDate: this.selectedTime.periodType === "now" ? null : this.toDate,
          deptDetail: this.displayDeptDetail,
          paymentDebits: this.displayPaymentDebits,
          initAmount: this.initAmount,
          saleAmount: this.displaySaleAmount,
          paidAmount: this.displayPaidAmount,
          debitAmount: this.displayDebitAmount,
          discountAmount: this.displayDiscountAmount,
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((item) => {});
  }

  exportAsXLSX() {
    this.dialogService
      .open(DialogPrintDeptDetailsComponent, {
        context: {
          shopId: this.shopId,
          shop: this.shop,
          uid: this.uid,
          user: this.user,
          object: this.customer,
          mode: "customer",
          type: "export",
          fromDate:
            this.selectedTime.periodType === "now" ? null : this.fromDate,
          toDate: this.selectedTime.periodType === "now" ? null : this.toDate,
          deptDetail: this.displayDeptDetail,
          paymentDebits: this.displayPaymentDebits,
          initAmount: this.initAmount,
          saleAmount: this.displaySaleAmount,
          paidAmount: this.displayPaidAmount,
          debitAmount: this.displayDebitAmount,
          discountAmount: this.displayDiscountAmount,
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((item) => {});
  }

  newReceipt() {
    this.close();
    // this.router.navigateByUrl(`/trade/${this.uid}/${this.customer.id}`);
    this.router.navigateByUrl(`/trade/${this.customer.id}`);
  }

  newPayment(isReceive: boolean) {
    let finance = new Finance();
    finance.shopId = this.shopId;
    finance.isReceive = isReceive;
    finance.type = "receipt";
    finance.customerId = this.customer.id;
    finance.customerName = this.customer.fullName;

    this.dialogService
      .open(DialogFinanceComponent, {
        context: {
          header: isReceive ? "Tạo phiếu thu" : "Tạo phiếu chi",
          mode: "new",
          shopId: this.shopId,
          uid: this.uid,
          user: this.user,
          shop: this.shop,
          finance: finance,
          groupFins: this.groupFins,
          persons: this.persons,
          type: isReceive ? "receive" : "issue",
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((value) => {
        if (value) {
          console.log(
            "🚀 ~ DialogDeptCustomerComponent ~ .onClose.subscribe ~ value:",
            value,
          );

          let updated = _.clone(value);
          updated.issueDate = value.issueDate;
          updated.note = value.note;
          updated.amount = !value.isReceive ? value.issueAmount : 0;
          updated.paid = value.isReceive ? value.receiveAmount : 0;

          this.customer.paidAmount += updated.paid - updated.amount;
          this.customer.debitAmount =
            this.customer.saleAmount - this.customer.paidAmount;
          this.customer.isSynced = false;

          //update customer
          this.customerService
            .setCustomerOverview(this.customer)
            .then((data) => {
              this.customer.hadChange = true;
              this.customerService.updateIndexedDb(this.customer);
            })
            .catch((err) => {});

          if (
            updated.issueDate >= this.fromDate &&
            updated.issueDate <= this.toDate
          ) {
            this.paymentDebits.push(updated);
          }

          this.step3_calculateDept();
        }
      });
  }

  viewDetail(item: Dept) {
    if (item.mode === "receipt" && item.receipt) {
      this.dialogService
        .open(DialogViewReceiptComponent, {
          context: {
            shopId: this.shopId,
            receipt: item.receipt,
            shop: this.shop,
          },
        })
        .onClose.subscribe((value) => {
          if (value) {
          }
        });
    } else if (item.mode === "payment") {
      //edit payment
      let itemMore = _.clone(item);
      itemMore.payment.id = itemMore.id;
      const orgFin = _.clone(itemMore.payment);

      this.dialogService
        .open(DialogFinanceComponent, {
          context: {
            mode: "edit",
            shopId: this.shopId,
            user: this.user,
            shop: this.shop,
            finance: itemMore.payment,
            groupFins: this.groupFins,
            persons: this.persons,
          },
          closeOnBackdropClick: false,
        })
        .onClose.subscribe((value: Finance) => {
          if (value) {
            let updated = _.find(this.displayPaymentDebits, { id: value.id });
            updated.issueDate = value.issueDate;
            updated.note = value.note;
            updated.amount = !value.isReceive ? value.issueAmount : 0;
            updated.paid = value.isReceive ? value.receiveAmount : 0;

            let updatedAll = _.find(this.paymentDebits, { id: value.id });
            updatedAll = updated;

            if (
              orgFin.issueAmount != value.issueAmount ||
              orgFin.receiveAmount != value.receiveAmount
            ) {
              const receiveChanged = value.isReceive
                ? value.receiveAmount - orgFin.receiveAmount
                : 0;
              console.log(
                "🚀 ~ DialogDeptCustomerComponent ~ .onClose.subscribe ~ receiveChanged:",
                receiveChanged,
              );
              const issueChanged = !value.isReceive
                ? value.issueAmount - orgFin.issueAmount
                : 0;

              this.customer.paidAmount += receiveChanged + issueChanged;
              this.customer.debitAmount =
                this.customer.saleAmount - this.customer.paidAmount;
              this.customer.isSynced = false;

              //update customer
              this.customerService
                .setCustomerOverview(this.customer)
                .then((data) => {
                  this.customer.hadChange = true;
                  this.customerService.updateIndexedDb(this.customer);
                })
                .catch((err) => {});
            }

            this.step3_calculateDept();
          }
        });
    }
  }

  selectTime(value) {
    this.selectedTime = value;
    this.fromDate = value.fromDate;
    this.toDate = value.toDate;

    this.step1_getReceipts();

    console.log("selectedTime:", this.selectedTime);
  }

  archiveData() {
    this.dialogService
      .open(DialogDeptCustomerArchiveComponent, {
        context: {
          shop: this.shop,
          uid: this.uid,
          user: this.user,
          customerCurrent: this.customer,
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((value: Customer) => {
        console.log(
          "🚀 ~ DialogDeptCustomerComponent ~ archiveData ~ value:",
          value,
        );
        if (value) {
          this.calculateCustomerStats(false);
        }
      });
  }

  //Load data
  //Person
  private getPersons() {
    // this.loading = true;
    this.personService
      .getPersons(this.shopId, "customer", this.customer.id)
      .snapshotChanges(["added", "removed"])
      .pipe(
        map((changes) =>
          changes.map((c) => ({
            id: c.payload.doc.id,
            ...c.payload.doc.data(),
          })),
        ),
        takeUntil(this.destroy$),
      )
      .subscribe((data) => {
        this.persons = data;
        console.log("getPersons:", this.persons);
        // this.loading = false;
      });
  }

  private getCatalogs(): void {
    // this.loading = true;

    this.catalogService
      .getCatalogsByMode(this.shopId, "groupFins")
      .snapshotChanges(["added", "removed"])
      .pipe(
        map((changes) =>
          changes.map((c) => ({
            id: c.payload.doc.id,
            ...c.payload.doc.data(),
          })),
        ),
        takeUntil(this.destroy$),
      )
      .subscribe(
        (data) => {
          console.log("getCatalogs/groupFins:", data);
          this.groupFins = data;
          // this.loading = false;
        },
        (error) => {
          // this.loading = false;
        },
      );
  }

  private async step1_getReceipts() {
    this.loading = true;

    this.saleAmount = 0;
    this.paidAmount = 0;
    this.debitAmount = 0;
    this.profitAmount = 0;
    this.totalQuantity = 0;

    this.receiptDebits = [];
    this.deptDetail = [];
    this.allReceipts = [];

    //initial Amount
    if (
      this.selectedTime.type === "allTime" &&
      this.customer.initAmount !== 0
    ) {
      let initData: Dept = new Dept();
      initData.id = "";
      initData.issueDate = moment().add(-1000, "years").toDate();
      initData.code = "Đầu kỳ";
      initData.note = "Đầu kỳ";
      initData.amount = this.customer.initAmount ? this.customer.initAmount : 0;
      initData.paid = 0;
      initData.debit = 0;
      initData.mode = "receipt";
      initData.timestamp = initData.issueDate.getTime();
      initData.receipt = null;
      let initDetail: DeptDetail = new DeptDetail();
      initDetail.issueDate = initData.issueDate;
      initDetail.code = initData.code;
      initDetail.note = initData.note;

      initDetail.productId = new Date().getTime().toString();
      initDetail.productCode = "ĐK";
      initDetail.productName = "Đầu kỳ";
      initDetail.productDescription = initData.note;
      initDetail.productUnitName = "";
      initDetail.discountPercent = 0;
      initDetail.discountAmount = 0;
      initDetail.quantity = 1;
      initDetail.price = initData.amount;
      initDetail.amount = initData.amount;
      initDetail.netAmount = initData.amount;
      initDetail.comment = "";
      initDetail.timestamp = initData.issueDate.getTime();

      initData.deptDetails = [initDetail];
      this.deptDetail.push(initDetail);
      this.receiptDebits.push(initData);
    }

    const querySnapshot =
      await this.receiptService.getReceiptTradesCustomerByDate(
        this.shopId,
        this.customer.id,
        this.fromDate,
        this.toDate,
      );

    querySnapshot.forEach((doc) => {
      let item = new Receipt();
      item = doc.data();
      item.id = doc.id;

      item.createdOn = convertTimestamp(item.createdOn);
      item.updatedOn = convertTimestamp(item.updatedOn);
      item.issueDate = convertTimestamp(item.issueDate);

      let expData: Dept = new Dept();
      expData.id = item.id;
      expData.issueDate = item.issueDate;
      expData.code = item.id.substring(item.id.length - 6, item.id.length);
      expData.note = item.note;
      expData.amount = isNaN(item.totalAmount) ? 0 : item.totalAmount;
      expData.paid = 0;
      expData.debit = 0;
      expData.mode = "receipt";
      expData.timestamp = item.issueDate.getTime();
      expData.receipt = item;

      this.totalQuantity += item.totalQuantity || 0;
      this.profitAmount += item.totalProfit || 0;

      //add detail
      let deptDetails: DeptDetail[] = [];
      _.forEach(item.receiptDetails, (itemD) => {
        let detail: DeptDetail = new DeptDetail();
        detail.issueDate = item.issueDate;
        detail.code = item.id.substring(item.id.length - 6, item.id.length);
        detail.note = item.note;

        detail.productId = itemD.productId;
        detail.productCode = itemD.productCode;
        detail.productName = itemD.productName;
        detail.productDescription = itemD.productDescription;
        detail.productUnitName = itemD.productUnitName;
        detail.discountPercent = itemD.discountPercent;
        detail.discountAmount = itemD.discountAmount;
        detail.quantity = itemD.quantity;
        detail.price = itemD.price;
        detail.amount = isNaN(itemD.amount) ? 0 : itemD.amount;
        detail.netAmount = itemD.netAmount;
        detail.comment = itemD.comment;
        detail.timestamp = item.issueDate.getTime();
        this.deptDetail.push(detail);
        deptDetails.push(detail);
      });
      expData.deptDetails = deptDetails;
      this.receiptDebits.push(expData);

      if (this.selectedTime.type === "allTime") {
        const rec = {
          issueDate: item.issueDate,
          totalProfit: item.totalProfit,
          totalAmount: item.totalAmount,
          totalQuantity: item.totalQuantity,
        };

        this.allReceipts.push(rec);
      }
    });

    this.loading = false;
    //Get finances
    await this.step2_getFinances();
  }

  private async step2_getFinances() {
    this.loading = true;
    this.allFinances = [];
    this.paymentDebits = [];

    const querySnapshot = await this.financeService.getFinancesByCustomerDept(
      this.shopId,
      this.customer.id,
      this.fromDate,
      this.toDate,
    );

    querySnapshot.forEach((doc) => {
      let item = new Finance();
      item = doc.data();
      item.id = doc.id;

      item.createdOn = convertTimestamp(item.createdOn);
      item.updatedOn = convertTimestamp(item.updatedOn);
      item.issueDate = convertTimestamp(item.issueDate);

      let expData: Dept = new Dept();
      expData.id = item.id;
      expData.issueDate = item.issueDate;
      expData.code = item.id.substring(item.id.length - 6, item.id.length);
      expData.note = item.note;
      expData.amount = 0;
      expData.paid = item.isReceive ? item.receiveAmount : -item.issueAmount;
      expData.debit = 0;
      expData.mode = "payment";
      expData.timestamp = item.issueDate.getTime();
      expData.payment = item;

      this.paymentDebits.push(expData);

      if (this.selectedTime.type === "allTime") {
        const rec = {
          issueDate: item.issueDate,
          isReceive: item.isReceive,
          receiveAmount: item.receiveAmount,
          issueAmount: item.issueAmount,
          amount: item.isReceive
            ? Number(item.receiveAmount || 0)
            : -Number(item.issueAmount || 0),
        };
        this.allFinances.push(rec);
      }
    });

    this.step3_calculateDept();

    this.loading = false;
  }

  private step3_calculateDept() {
    this.saleAmount = 0;
    this.paidAmount = 0;
    this.debitAmount = 0;
    this.discountAmount = 0;

    let depts: Dept[] = [...this.receiptDebits, ...this.paymentDebits];
    depts = _.sortBy(depts, ["issueDate"]);

    this.allDebits = [];
    _.forEach(depts, (item) => {
      let expData: Dept = new Dept();
      expData = item;
      expData.debit = this.debitAmount + (item.amount - item.paid);

      this.allDebits.push(expData);

      this.saleAmount += isNaN(item.amount) ? 0 : item.amount;
      this.paidAmount += item.paid;
      this.debitAmount = expData.debit;

      if (item.receipt && item.receipt.discountAmount != 0) {
        this.discountAmount += item.receipt.discountAmount;
      }
    });
    console.log("step3_calculateDept/saleAmount", this.saleAmount);

    //display value
    this.initAmount = this.customer.debitAmount - this.debitAmount;
    this.displaySaleAmount = this.saleAmount;
    this.displayPaidAmount = this.paidAmount;
    this.displayDebitAmount = this.debitAmount;
    this.displayDiscountAmount = this.discountAmount;
    this.displayDebits = [...this.allDebits];
    this.displayDeptDetail = [...this.deptDetail];
    this.displayPaymentDebits = [...this.paymentDebits];

    if (
      this.selectedTime.type === "allTime" &&
      (this.customer.saleAmount !== this.saleAmount ||
        this.customer.paidAmount !== this.paidAmount ||
        this.customer.debitAmount !== this.debitAmount)
    ) {
      this.customer.totalAmount = this.saleAmount + this.customer.initAmount;
      this.customer.saleAmount = this.saleAmount;
      this.customer.paidAmount = this.paidAmount;
      this.customer.debitAmount = this.debitAmount;
      this.customer.profitAmount = this.profitAmount;
      this.customer.totalQuantity = this.totalQuantity;
      this.customer.totalInvoices = this.allReceipts.length;
      this.customer.isSynced = true;

      //not save value, reset customer stats
      this.customer.isArchived = false;
      this.calculateCustomerStats(false);
    }
  }

  private calculateCustomerStats(isArchived: boolean) {
    this.loading = true;
    const d = new Date(this.customer.updatedOn);

    const monthKey = isArchived
      ? `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`
      : "initial";

    this.customerService
      .calculateCustomerStats(
        this.shopId,
        monthKey,
        this.customer.id,
        this.customer.fullName,
        this.customer.mobile,
        this.customer.address,
        this.customer.initAmount,
      )
      .subscribe(
        (data) => {
          console.log(`🚀 ~ calculateCustomerStats ${monthKey} ~ data:`, data);

          this.customer.isArchived =
            monthKey === "initial" ? true : this.customer.isArchived;
          this.customer.hadChange = true;
          this.customer.isSynced = true;

          this.customer.totalAmount = Math.round(Number(data.totalAmount));
          this.customer.saleAmount = Math.round(Number(data.saleAmount));
          this.customer.paidAmount = Math.round(Number(data.paidAmount));
          this.customer.debitAmount = Math.round(Number(data.debitAmount));
          this.customer.profitAmount = Math.round(Number(data.profitAmount));
          this.customer.totalQuantity = Math.round(Number(data.totalQuantity));
          this.customer.totalInvoices = Math.round(Number(data.totalInvoices));

          this.customerService.updateIndexedDb(this.customer);

          this.loading = false;
          this.submitted = false;

          if (monthKey !== "initial") {
            this.step1_getReceipts();
          }
        },
        (err) => {
          console.log(err);
        },
      );
  }
}
